const MyBanners = () => {
  return <p>All banners created by the user</p>;
};

export default MyBanners;
